module.exports = __webpack_public_path__ + "static/media/icon_findmap.59aeae9e.svg";